import { ChatMessageIn, ChatMessageOut } from "./index";
import { MessageUI } from "./types";

/**
 * 對話頁面主體
 * 顯示對話內容
 */
export function ConversationMain({
  messages,
  messagesEndRef,
}: {
  messages: MessageUI[];
  messagesEndRef: React.RefObject<HTMLDivElement>;
}) {
  function openFullscreen(url: string, title: string) {
    const fullscreenTitle = document.getElementById("fullscreen-title");
    const fullscreenUrl = document.getElementById(
      "fullscreen-url",
    ) as HTMLAnchorElement | null;
    const fullscreenIframe = document.getElementById(
      "fullscreen-iframe",
    ) as HTMLIFrameElement | null;
    const fullscreenModal = document.getElementById("fullscreen-modal");
    if (
      !fullscreenTitle ||
      !fullscreenUrl ||
      !fullscreenIframe ||
      !fullscreenModal
    )
      return;
    fullscreenTitle.textContent = title || "網站預覽";
    fullscreenUrl.href = url || "";
    fullscreenUrl.textContent = url || "";
    fullscreenUrl.target = "_blank";
    fullscreenIframe.src = url;
    fullscreenModal.classList.remove("hidden-important");
    document.body.style.overflow = "hidden-important";
  }

  const funcs = {
    openFullscreen,
  };

  async function shareWebsite() {
    const iframe = document.getElementById(
      "fullscreen-iframe",
    ) as HTMLIFrameElement | null;
    const currentSrc = iframe?.src;
    const shareText = "從麻薏Mayi AI生成的網站，分享給你";
    try {
      await navigator.clipboard.writeText(shareText + "\n\n" + currentSrc);
      alert("文字已複製，可以貼上分享！");
    } catch (err) {
      console.error("複製失敗", err);
    }

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareText,
          text: "快來與我一起體驗吧～",
          url: currentSrc,
        });
        console.log("分享成功！");
      } catch (err) {
        console.error("使用者取消或發生錯誤", err);
      }
    } else {
      alert("您的瀏覽器不支援 Web Share API");
    }
  }

  /**
   * 關閉全螢幕 modal
   */
  function closeFullscreen() {
    const fullscreenIframe = document.getElementById(
      "fullscreen-iframe",
    ) as HTMLIFrameElement | null;
    const fullscreenModal = document.getElementById("fullscreen-modal");
    if (!fullscreenIframe || !fullscreenModal) return;
    fullscreenIframe.src = "";
    fullscreenModal.classList.add("hidden-important");
    document.body.style.overflow = "auto-important";
  }
  /**
   * 重新整理全螢幕 modal 內的 iframe
   */
  function refreshFullscreenIframe() {
    const iframe = document.getElementById(
      "fullscreen-iframe",
    ) as HTMLIFrameElement | null;
    const fullscreenLoading = document.getElementById(
      "fullscreen-loading",
    ) as HTMLDivElement | null;
    const currentSrc = iframe?.src;
    if (!iframe || !currentSrc) return;
    fullscreenLoading?.classList.remove("hidden-important");
    iframe.classList.add("hidden-important");
    iframe.src = "";
    setTimeout(() => {
      if (!iframe || !currentSrc) return;
      fullscreenLoading?.classList.add("hidden-important");
      iframe.classList.remove("hidden-important");
      iframe.src = currentSrc;
    }, 300);
  }
  return (
    <>
      <main className="chat-container viewport-height flex flex-col">
        <div className="flex-1 pr-4 pl-4 overflow-y-auto space-y-3 md:space-y-4 h-full pb-20 md:pb-24 max-w-7xl mx-auto w-full">
          <div className="flex-1 overflow-hidden relative">
            <div className="h-full overflow-y-auto py-4 px-2 md:px-6 pb-12 space-y-2">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`flex ${message.sender === "user" ? "justify-end animate-slide-down" : "justify-start animate-slide-down"}`}
                >
                  {message.sender === "user" ? (
                    <ChatMessageIn message={message} />
                  ) : (
                    <ChatMessageOut message={message} funcs={funcs} />
                  )}
                </div>
              ))}

              <div
                id="fullscreen-modal"
                className="hidden-important fullscreen-modal"
              >
                <div className="fullscreen-header">
                  <div className="flex items-center space-x-3">
                    <button
                      onClick={closeFullscreen}
                      className="text-white hover:text-gray-200 transition-colors bg-white/10 px-4 py-2"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                    <div className="flex items-center space-x-2">
                      <h3
                        id="fullscreen-title"
                        className="text-lg text-nowrap font-semibold"
                      >
                        網站預覽
                      </h3>
                      <a
                        id="fullscreen-url"
                        className="text-white/80 text-sm"
                      ></a>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={refreshFullscreenIframe}
                      className="text-white/80 hover:text-white text-nowrap transition-colors px-3 py-2 bg-white/10 rounded-lg"
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                    <button
                      onClick={shareWebsite}
                      className="text-white/80 hover:text-white text-nowrap transition-colors px-3 py-2 bg-white/10 rounded-lg"
                    >
                      <i className="fas fa-share"></i>
                    </button>
                  </div>
                </div>
                <div
                  id="fullscreen-loading"
                  className="fullscreen-iframe hidden-important bg-soft-green w-full h-full flex items-center justify-center"
                >
                  <div className="flex items-center space-x-2">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-earth-green"></div>
                    <span>載入網站中...</span>
                  </div>
                </div>
                <iframe
                  id="fullscreen-iframe"
                  className="fullscreen-iframe"
                  sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-same-origin"
                ></iframe>
              </div>
              <div ref={messagesEndRef} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
